import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;
  padding: 15px 30px 20px 30px;

  h3 {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .MuiDataGrid-selectedRowCount {
    color: transparent !important;
  }
  .row {
    --bs-gutter-x: 0 !important;
    --bs-gutter-y: 0 !important;
  }

  .super-app-theme--header {
    background: #8850bf !important;
  }

  .box-month {
    border: 0.0938rem solid #dfe1e6;
    padding: 1.25rem;
  }
`;

export const SeparatorLine = styled.p`
  border-bottom: 1px solid #ededed;
  padding: 0;
  margin: 0;
`;
